import React from "react";

function NoRoute() {
  return (
    <div>
      <h1 style={{ textAlign: "center", color: "#131921" }}>
        This Page Doesn't Exist!
      </h1>
    </div>
  );
}

export default NoRoute;
